import { render, staticRenderFns, recyclableRender, components } from "./u--textarea.vue?vue&type=template&id=2d579347&"
var renderjs
import script from "./u--textarea.vue?vue&type=script&lang=js&"
export * from "./u--textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u--textarea/u--textarea.vue"
export default component.exports